import { render, staticRenderFns } from "./DateDistributionChart.vue?vue&type=template&id=0c996450"
import script from "./DateDistributionChart.vue?vue&type=script&lang=js"
export * from "./DateDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports